// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"3a24ea28","93":"aa5e8c0b","152":"348225cf","177":"37a29f7d","204":"c39386a5","361":"ed1b371f","428":"886e06a8","490":"81f86631","590":"64c22752","653":"0ca66260","801":"f701bf2f","838":"a2702a9c","923":"84165b8b","934":"dae5dac8"}[chunkId] + ".chunk.js";
};